// Project `system_type` values returned by the backend (`GET /project/system/types`).
// `only_battery` is only offered when the `enable_battery_only_option` feature flag is on.
export const SYSTEM_TYPE = {
  WITH_BATTERY: 'with_battery',
  WITHOUT_BATTERY: 'without_battery',
  ONLY_BATTERY: 'only_battery',
} as const

export type KnownSystemType = typeof SYSTEM_TYPE[keyof typeof SYSTEM_TYPE]

/** System types the front knows how to handle; any other value from the backend is ignored/hidden. */
export const KNOWN_SYSTEM_TYPES: readonly KnownSystemType[] = Object.values(SYSTEM_TYPE)

export function isKnownSystemType(systemType?: string | null): systemType is KnownSystemType {
  return KNOWN_SYSTEM_TYPES.includes(systemType as KnownSystemType)
}

/** i18n key of the system type label shown in the header, or `null` for unknown/empty values. */
export function systemTypeLabelKey(systemType?: string | null): string | null {
  return isKnownSystemType(systemType) ? `header.project.system_types.${systemType}` : null
}

export function isOnlyBattery(systemType?: string | null): boolean {
  return systemType === SYSTEM_TYPE.ONLY_BATTERY
}

/** Battery equipment is part of the project (`with_battery` or `only_battery`). */
export function hasBattery(systemType?: string | null): boolean {
  return systemType === SYSTEM_TYPE.WITH_BATTERY || isOnlyBattery(systemType)
}
